import { loadObjectFromServer, getData } from "@/utils";

export async function getInvoiceList() {
  const APP_ROUTES = loadObjectFromServer("APP_ROUTES");
  const response = await getData(APP_ROUTES.INVOICES);
  return response;
}
